import Img from '../../../../assets/icons/location-icon.svg';
import dateUtils from '../../../../utils/date-format';
import { LectureDatamodel, LecturePart } from '../course-lectures';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

const getLecturerName = (lectures: UserSummaryType[]) => {
  return lectures
    .map((user) => `${user.firstName} ${user.lastName}`)
    .join(', ');
};

export interface LectureItemData {
  id: number;
  lecturePart: LecturePart;
  lectureSubject: string;
  index: number;
  lecturer: UserSummaryType[];
  classNumber: number;
  howManyPresent: number;
  howManyPresentOutOf: number;
  shouldShowHowManyPresent: boolean;
  shouldAllowStartEndClass: boolean;
}

export interface LectureItemModel {
  data: LectureItemData;
}

export const LectureItem: React.FC<LectureItemModel> = ({ data }) => {
  const allowStartAndEndClassBorder = {
    borderRight: data.shouldAllowStartEndClass ? '3px solid #185FD3' : '',
  };
  return (
    <div>
      <div
        style={{
          ...allowStartAndEndClassBorder,
          marginTop: '10px',
          display: 'flex',
          flexDirection: 'row',
          maxWidth: '850px',
          paddingTop: '15px',
          paddingBottom: '15px',
          backgroundColor: 'white',
          borderRadius: '15px',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '120px',
              borderLeft: '1px solid #DED9D9',
              borderRadius: '1px',
            }}
          >
            <div
              style={{
                color: '#185FD3',
                fontSize: '26px',
                fontWeight: 'bold',
              }}
            >
              {dateUtils.formatToTwoDigits(data.index)}
            </div>
            <div>{dateUtils.displayFormatDate(data.lecturePart.startTime)}</div>
            <div style={{ direction: 'ltr' }}>
              {dateUtils.formatTimeRangeBetweenDates(
                data.lecturePart.startTime,
                data.lecturePart.endTime,
              )}
            </div>
            <div>{data.shouldShowHowManyPresent}</div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              marginRight: '10px',
            }}
          >
            <div>
              <div style={{ color: '#070707', fontSize: '18px' }}>
                {data.lectureSubject}
              </div>
              <div style={{ color: '#070707', fontSize: '14px' }}>
                {getLecturerName(data.lecturer)}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <img src={Img} width={'15px'} />
              <div style={{ marginRight: '5px', color: '#6A6A6A' }}>
                כיתה {data.classNumber}
              </div>
            </div>
          </div>
        </div>

        {data.shouldAllowStartEndClass && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '30px',
            }}
          >
            <div
              style={{
                padding: '10px',
                backgroundColor: 'rgba(24,95,211,0.1)',
                borderRadius: '10px',
              }}
            >
              התחל שיעור
            </div>
            <div style={{ width: '5px' }} />
            <div
              style={{
                padding: '10px',
                backgroundColor: 'rgba(24,95,211,0.1)',
                borderRadius: '10px',
              }}
            >
              סיים שיעור
            </div>
          </div>
        )}

        {!data.shouldAllowStartEndClass && data.shouldShowHowManyPresent && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '30px',
            }}
          >
            <div style={{ color: '#070707', fontSize: '14px' }}>
              {data.howManyPresent} נוחכים מתוך {data.howManyPresentOutOf}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
